var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogosMicrosoft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:microsoft",
    clipPath: "url(#clip0_641_9507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.93589 9.42905H0.248047V-0.258789H9.93589V9.42905Z",
    fill: "#F1511B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.6327 9.42905H10.9448V-0.258789H20.6327V9.42905Z",
    fill: "#80CC28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.9357 20.1295H0.248047V10.4417H9.9357V20.1295Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.6327 20.1295H10.9448V10.4417H20.6327V20.1295Z",
    fill: "#FBBC09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_9507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white",
    transform: "translate(-0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosMicrosoft);
export default __webpack_public_path__ + "static/media/logos_microsoft.a094ec1a56020fe8864603495d056749.svg";
export { ForwardRef as ReactComponent };